import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NavigateService } from '@shared/services/navigate.service';
import { filter, map, mergeMap } from 'rxjs/operators';

export enum FaqContentType {
  GLOBAL = 'global',
  ACCOUNT = 'account'
}

@Component({
  selector: 'help-faq-content',
  templateUrl: './help-faq-content.component.html',
  styleUrls: ['./help-faq-content.component.scss']
})
export class HelpFaqContentComponent {
  faqContentType: FaqContentType = FaqContentType.GLOBAL;

  private destroyRef = inject(DestroyRef);

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private n: NavigateService
  ) {
    this.listenChangeTab();
  }

  listenChangeTab(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.route),
        mergeMap((route) => route.data),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((routeData) => {
        this.faqContentType = routeData.faqContentType;
      });
  }

  replaceTags(content: string): string {
    const host = `${window.location.protocol}//${window.location.host}`;
    content = content.replace(/{{sign-up-path}}/g, host + this.n.getPath('register'));
    content = content.replace(/{{forgot-pass-path}}/g, host + this.n.getPath('reset'));
    content = content.replace(/{{settings-team-path}}/g, host + this.n.getPath('team-settings'));
    return content;
  }
}
